import type { EvaluationPeriodOption } from '@/pages/ManagerAssessment/Evaluation/types';
import type { EvaluationPeriod } from '@/types/manager-assessment/Evaluation';

export const mapEvaluationPeriodsToOptions = (
    evaluationPeriodsRaw: EvaluationPeriod[],
): EvaluationPeriodOption[] =>
    evaluationPeriodsRaw.map((period) => ({
        value: period.id,
        label: period.name,
        from: period.startDate,
        to: period.endDate,
    }));
